// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bsaeikuolsitryyqhhgg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJzYWVpa3VvbHNpdHJ5eXFoaGdnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE4Nzg4NDQsImV4cCI6MjA2NzQ1NDg0NH0.G3LkeIszNfsfU9K2NOppD-5EyjVERCenIJd9HqGHHFs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});